export enum BaseItemType {
  QUARTER_STAFF = 0,
  STUN_BATON = 1,
  LONG_SWORD = 2,
  VIBRO_SWORD = 3,
  SHORT_SWORD = 4,
  VIBRO_BLADE = 5,
  DOUBLE_BLADED_SWORD = 6,
  VIBRO_DOUBLE_BLADE = 7,
  LIGHTSABER = 8,
  DOUBLE_BLADED_LIGHTSABER = 9,
  SHORT_LIGHTSABER = 10,
  LIGHTSABER_CRYSTALS = 11,
  BLASTER_PISTOL = 12,
  HEAVY_BLASTER = 13,
  HOLD_OUT_BLASTER = 14,
  ION_BLASTER = 15,
  DISRUPTER_PISTOL = 16,
  SONIC_PISTOL = 17,
  ION_RIFLE = 18,
  BOWCASTER = 19,
  BLASTER_CARBINE = 20,
  DISRUPTER_RIFLE = 21,
  SONIC_RIFLE = 22,
  REPEATING_BLASTER = 23,
  HEAVY_REPEATING_BLASTER = 24,
  FRAGMENTATION_GRENADES = 25,
  STUN_GRENADES = 26,
  THERMAL_DETONATOR = 27,
  POISON_GRENADE = 28,
  FLASH_GRENADE = 29,
  SONIC_GRENADE = 30,
  ADHESIVE_GRENADE = 31,
  CRYOBAN_GRENADE = 32,
  FIRE_GRENADE = 33,
  ION_GRENADE = 34,
  JEDI_ROBE = 35,
  JEDI_KNIGHT_ROBE = 36,
  JEDI_MASTER_ROBE = 37,
  ARMOR_CLASS_4 = 38,
  ARMOR_CLASS_5 = 39,
  ARMOR_CLASS_6 = 40,
  ARMOR_CLASS_7 = 41,
  ARMOR_CLASS_8 = 42,
  ARMOR_CLASS_9 = 43,
  MASK = 44,
  GAUNTLETS = 45,
  FOREARM_BANDS = 46,
  BELT = 47,
  IMPLANT_1 = 48,
  IMPLANT_2 = 49,
  IMPLANT_3 = 50,
  DATA_PAD = 52,
  ADRENALINE = 53,
  COMBAT_SHOTS = 54,
  MEDICAL_EQUIPMENT = 55,
  DROID_REPAIR_EQUIPMENT = 56,
  CREDITS = 57,
  TRAP_KIT = 58,
  SECURITY_SPIKES = 59,
  PROGRAMMING_SPIKES = 60,
  GLOW_ROD = 61,
  COLLAR_LIGHT = 62,
  TORCH = 63,
  PLOT_USEABLE_ITEMS = 64,
  AESTHETIC_ITEM = 65,
  DROID_LIGHT_PLATING = 66,
  DROID_MEDIUM_PLATING = 67,
  DROID_HEAVY_PLATING = 68,
  DROID_SEARCH_SCOPE_X = 69,
  DROID_MOTION_SENSORS_X = 70,
  DROID_SONIC_SENSORS_X = 71,
  DROID_TARGETING_COMPUTERS = 72,
  DROID_COMPUTER_SPIKE_MOUNT_X = 73,
  DROID_SECURITY_SPIKE_MOUNT = 74,
  DROID_SHIELD = 75,
  DROID_UTILITY_DEVICE = 76,
  BLASTER_RIFLE = 77,
  GHAFFI_STICK = 78,
  WOKIE_WARBLADE = 79,
  GAMMOREAN_BATTLEAXE = 80,
  CREATURE_ITEM_SLASH = 81,
  CREATURE_ITEM_PIERCE = 82,
  CREATURE_WEAPON_SL_PRC = 83,
  CREATURE_HIDE_ITEM = 84,
  BASIC_CLOTHING = 85,
  PAZAAK_CARD = 86,
  PAZAAK_SIZEBOARD = 87,
  STEALTH_UNIT = 88,
  REVAN_ARMOR = 89,
  DISGUISE_ITEM = 90,
  SQUAD_RECOVERY_KIT = 91,
  /**
   * TSL
   */
  TSL_WRIST_LAUNCHER = 91,
  TSL_ROCKET = 92,
  TSL_FORCE_PIKE = 93,
  TSL_SQUAD_RECOVERY_KIT = 94,
  TSL_CHEMICALS = 95,
  TSL_COMPONENTS = 96,
  TSL_SONIC_GENADE_TYPE_2 = 97,
  TSL_ARMOR_ARMD_FLIGHT_SUIT = 98,
  TSL_RESTICTIVE_JEDI_ROBE = 99,
  TSL_SALVE_OUTFIT = 100,
  TSL_UPGRADE_ITEMS = 101,
  TSL_ARMOR_ZEISON_SHA = 102,
  TSL_MINER_UNIFORM = 103
}
